import axios from "axios";
import { apiConfig } from "../config/authConfig";
import { CredentialManager } from "../classes/credentialManager";
import { AppSetting as AppSetting } from "../types/appSetting";

export namespace AppSettingService {
	const credentialManager = CredentialManager.getInstance();

	/**********
	 * Get all application settings. Settings that are masked will not return values.
	 **********/
	export async function getAppSettings() {
		const apiResponse = axios.get(
			apiConfig.default + "/appSetting",
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}

	/**********
	 * Get a single application setting by its name. Settings that are masked will return their plaintext value.
	 * @param name The name of the application setting to retrieve.
	 **********/
	export async function getAppSettingByName(name: string) {
		const apiResponse = axios.get(
			apiConfig.default + "/appSetting/name/" + name,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}

	/**********
	 * Convert one api response object to one AppSetting.
	 * @param data AppSetting response data from an API.
	 **********/
	export function mapAppSetting(data: any) {
		let item: AppSetting = new AppSetting();
		item.id = data.id;
		item.name = data.name;
		item.value = data.value;
		item.type = data.type;
		item.mask = data.mask;

		return item;
	}

	/**********
	 * Convert an array of api response objects to an array of AppSettings.
	 * @param data AppSettings data from an API response.
	 **********/
	export function mapAppSettings(data: any) {
		let items: AppSetting[] = [];

		if(Array.isArray(data) && data.length > 0){
			data.map((item: any) => {
				items.push(mapAppSetting(item));
			})
		}

		return items;
	}

	/**********
	 * Update application settings.
	 * @param setting An IAppSettings objects.
	 **********/
	export async function setAppSetting(setting: AppSetting) {
		const apiResponse = axios.put(
			apiConfig.default + "/appSetting",
			setting,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}
}
